<script setup>
import { formattedDate, swalError, humanizeText } from '@/helper';
import { capitalize, onMounted, ref } from 'vue';
import { get_notifications } from '@/services/notifications';
import { parse_notification_response } from '@/helper';
import notificationList from '@/components/notificationList.vue'

const activities = ref([
  {
    date: "date",
    day: 'day',
    title: 'title',
    description: 'description',
    class: 'class'
  }
])

const isLoading = ref(true)
onMounted(async()=>{
  await retrieve_notifications()
  isLoading.value = false
})

async function retrieve_notifications(){
  let response = await get_notifications({limit: 3, type: 'unread'})
  if (response.error){
    // Don't show error for customers, just set empty array
    activities.value = []
    console.error('Failed to load notifications:', response.result || response.error)
    return
  }
  activities.value = parse_notification_response(
    response.result.data.data, 
    response.result.data.included
  )
}
</script>

<template>
  <div class="card height-equal first-row">
    <div class="card-header card-no-border">
      <div class="header-top">
        <h5 class="m-0">Activity</h5>
        <router-link :to="{name: 'activities'}" class="btn btn-light-primary py-1">
          View More
        </router-link>
      </div>
    </div>
    <template v-if="isLoading">
      <div class="card-body">
        <loadingCard loadingType="list"/>
      </div> 
    </template>
    <template v-else>
      <div class="card-body pt-0 pb-2 pe-0">
        <ul v-if="activities.length !== 0" class="h-test">
          <li class="d-flex" v-for="item in activities">
            <notificationList :notification="item" />
          </li>
        </ul>
        <template v-else>
          <div class="center-card">
            <EmptyCard text="No new notification at the moment" :needLink="false"/>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
